import { axios } from '@Root/API'

export const remove = programmeId => {
	return axios.delete(`programs/${programmeId}`)
}
